// The parent is established by the initialization handshake, never by a URL parameter.
let parentOrigin: string | null = null;

export function setAdminParentOrigin(origin: string) {
  parentOrigin = origin;
}

export function notifyAdmin(
  type: "campnerd.booking-created" | "campnerd.back-to-bookings",
  bookingId?: string,
) {
  if (window.self === window.top || !parentOrigin) return;
  window.parent.postMessage({ type, bookingId }, parentOrigin);
}
